<template>
  <div ref="rootRef" class="rich-html-case rich-html-case--channelAdvertisingFundManagementPlatform">
<!-- Top Banner (poster1.html) -->
<section class="poster-banner">
  <div class="poster">
    <div class="bg-glow-1"></div>
    <div class="bg-glow-2"></div>
    <div class="bg-dots"></div>
    <div class="geo-ring"></div>
    <div class="geo-diamond"></div>
    <div class="geo-dots"></div>

    <svg class="bg-wave" viewBox="0 0 1920 280" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
      <path d="M0 280 L0 160 C200 140, 420 200, 640 150 C860 100, 1080 180, 1300 140 C1520 100, 1700 170, 1920 130 L1920 280 Z" fill="rgba(37,99,235,0.04)"/>
      <path d="M0 280 L0 200 C240 180, 480 230, 720 190 C960 150, 1200 220, 1440 180 C1680 140, 1820 190, 1920 170 L1920 280 Z" fill="rgba(37,99,235,0.03)"/>
      <path d="M0 280 L0 240 C260 220, 520 260, 780 230 C1040 200, 1300 250, 1560 220 C1700 210, 1820 240, 1920 230 L1920 280 Z" fill="rgba(37,99,235,0.02)"/>
      <path d="M0 180 C200 155, 400 210, 600 170 C800 130, 1000 200, 1200 160 C1400 120, 1600 180, 1920 140" stroke="rgba(37,99,235,0.12)" stroke-width="1.5" fill="none"/>
      <path d="M0 220 C240 195, 480 240, 720 200 C960 160, 1200 230, 1440 190 C1680 150, 1800 200, 1920 180" stroke="rgba(37,99,235,0.08)" stroke-width="1.2" fill="none"/>
    </svg>

    <div class="poster__content">
      <div class="poster__left">
        <div class="poster__badge">B2B SaaS Platform</div>
        <h1 class="poster__title">渠道广告<br><span>资金管理台</span></h1>
        <p class="poster__subtitle">
          全媒体广告账户与资金一站式管理平台，覆盖 14 种主流广告媒体，实现开户、充值、管理与数据看板的全链路数字化运营。
        </p>
        <div class="poster__stats">
          <div class="poster__stat">
            <div class="poster__stat-num"><span>14</span></div>
            <div class="poster__stat-label">广告媒体</div>
          </div>
          <div class="poster__stat">
            <div class="poster__stat-num"><span>2</span>端协同</div>
            <div class="poster__stat-label">客户端 + 管理端</div>
          </div>
          <div class="poster__stat">
            <div class="poster__stat-num"><span>8</span>大模块</div>
            <div class="poster__stat-label">全流程覆盖</div>
          </div>
          <div class="poster__stat">
            <div class="poster__stat-num"><span>USD</span></div>
            <div class="poster__stat-label">多币种结算</div>
          </div>
        </div>
        <div class="poster__features">
          <div class="poster__feature">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="9" y1="21" x2="9" y2="9"/></svg>
            全媒体开户
          </div>
          <div class="poster__feature">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2v20M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/></svg>
            自助充值
          </div>
          <div class="poster__feature">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/></svg>
            账户管理
          </div>
          <div class="poster__feature">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 20V10"/><path d="M12 20V4"/><path d="M6 20v-6"/></svg>
            数据看板
          </div>
        </div>
      </div>

      <div class="poster__right">
        <div class="mockup-wrapper">
          <div class="desktop-mockup">
            <div class="desktop-chrome">
              <div class="desktop-chrome__dots">
                <div class="desktop-chrome__dot red"></div>
                <div class="desktop-chrome__dot yellow"></div>
                <div class="desktop-chrome__dot green"></div>
              </div>
              <div class="desktop-chrome__url">fund.adchannel.com/console</div>
              <div class="desktop-chrome__actions">
                <div class="desktop-chrome__action"></div>
                <div class="desktop-chrome__action"></div>
              </div>
            </div>
            <img class="desktop-screen" :src="bannerDashboardImage" alt="工作台界面" @error="onImageError" />
          </div>

          <div class="float-card float-card--top-left">
            <div class="float-card__title">覆盖广告媒体</div>
            <div class="float-card__value"><span>14</span> 家</div>
            <div class="float-card__trend">Google · Meta · TikTok · Bing…</div>
          </div>
          <div class="float-card float-card--top">
            <div class="float-card__title">活跃账户余额</div>
            <div class="float-card__value"><span>$</span>128,450</div>
            <div class="float-card__trend">+12.5% vs last week</div>
          </div>
          <div class="float-card float-card--mid-right">
            <div class="float-card__title">待处理充值</div>
            <div class="float-card__value"><span>6</span> 笔</div>
            <div class="float-card__trend">总额 $32,800 USD</div>
          </div>
          <div class="float-card float-card--bottom">
            <div class="float-card__title">今日开户申请</div>
            <div class="float-card__value"><span>23</span> 户</div>
            <div class="float-card__trend">审核中 8 / 通过 15</div>
          </div>
          <div class="float-card float-card--bottom-right">
            <div class="float-card__title">账户空户率</div>
            <div class="float-card__value"><span>50</span>%</div>
            <div class="float-card__trend">近28天封户趋势 ↓</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Project Introduction -->
<section class="project-intro">
  <div class="project-intro__inner">
    <img class="project-intro__title-img" :src="introduceText" alt="项目介绍" />
    <p class="project-intro__text fontRegular">{{ projectIntroduction }}</p>
  </div>
</section>

<div class="page page-detail">
  <div class="s-divider"></div>

  <!-- ======================== OVERVIEW ======================== -->
  <div class="section">
    <div class="sec-label">
      <div class="sec-label__dot" style="background:#2563EB;"></div>
      <span class="sec-label__cn">项目概览</span>
      <span class="sec-label__sep">/</span>
      <span class="sec-label__en">Project Overview</span>
    </div>
    <div class="overview-grid">
      <div class="overview-card">
        <div class="overview-card__icon blue">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#2563EB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/><line x1="9" y1="21" x2="9" y2="9"/></svg>
        </div>
        <div class="overview-card__title">全媒体账户管理</div>
        <div class="overview-card__desc">支持 Google、Facebook、TikTok、Bing、Twitter、Taboola 等 14 种主流广告媒体，统一管理开户、充值与账户操作。</div>
      </div>
      <div class="overview-card">
        <div class="overview-card__icon indigo">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#6366F1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2v20M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/></svg>
        </div>
        <div class="overview-card__title">智能资金流转</div>
        <div class="overview-card__desc">钱包自助充值、广告账户充值、账户清零、资金流水等全链路资金管理，支持 USD、INR 等多币种结算。</div>
      </div>
      <div class="overview-card">
        <div class="overview-card__icon violet">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#8B5CF6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4-4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></svg>
        </div>
        <div class="overview-card__title">双端协同体系</div>
        <div class="overview-card__desc">客户端自助开户/充值/管理，管理端审核/分配/统计/运营，两端实时协同。</div>
      </div>
      <div class="overview-card">
        <div class="overview-card__icon cyan">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#06B6D4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/></svg>
        </div>
        <div class="overview-card__title">数据驱动决策</div>
        <div class="overview-card__desc">工作台实时看板展示账户空户率、封户率、充值数据、媒体排行榜等关键指标。</div>
      </div>
      <div class="overview-card">
        <div class="overview-card__icon amber">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#F59E0B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
        </div>
        <div class="overview-card__title">代理与权限管控</div>
        <div class="overview-card__desc">管理端支持代理管理、客户分层、角色权限精确至页面级，保障资金安全。</div>
      </div>
      <div class="overview-card">
        <div class="overview-card__icon emerald">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#10B981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>
        </div>
        <div class="overview-card__title">全流程运营支撑</div>
        <div class="overview-card__desc">消息通知、帮助中心、用户反馈、业绩统计、钱包流水，覆盖运营全场景。</div>
      </div>
    </div>
  </div>

  <div class="s-divider"></div>

  <!-- ======================== ARCHITECTURE ======================== -->
  <div class="section">
    <div class="sec-label">
      <div class="sec-label__dot" style="background:#6366F1;"></div>
      <span class="sec-label__cn">系统架构</span>
      <span class="sec-label__sep">/</span>
      <span class="sec-label__en">System Architecture</span>
    </div>
    <div class="tech-arch">
      <!-- Layer 1: Presentation -->
      <div class="tech-layer">
        <div class="tech-layer__label">
          <div class="tech-layer__label-icon">🖥️</div>
          <div class="tech-layer__label-text">展示层</div>
          <div class="tech-layer__label-sub">Presentation</div>
        </div>
        <div class="tech-layer__content">
          <div class="tech-node tech-node--blue"><div class="tech-node__dot"></div>React SPA · 客户端</div>
          <div class="tech-node tech-node--violet"><div class="tech-node__dot"></div>React SPA · 管理端</div>
          <div class="tech-node tech-node--slate"><div class="tech-node__dot"></div>Ant Design Pro</div>
          <div class="tech-node tech-node--slate"><div class="tech-node__dot"></div>Umi.js</div>
          <div class="tech-node tech-node--blue"><div class="tech-node__dot"></div>ECharts · 数据可视化</div>
          <div class="tech-node tech-node--slate"><div class="tech-node__dot"></div>Redux / DVA</div>
        </div>
      </div>

      <div class="tech-flow">
        <div class="tech-flow__line">
          <div class="tech-flow__arrow">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94A3B8" stroke-width="2"><path d="M12 5v14M19 12l-7 7-7-7"/></svg>
            HTTP / HTTPS
          </div>
          <div class="tech-flow__arrow">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94A3B8" stroke-width="2"><path d="M12 5v14M19 12l-7 7-7-7"/></svg>
            WebSocket
          </div>
        </div>
      </div>

      <!-- Layer 2: Gateway -->
      <div class="tech-layer">
        <div class="tech-layer__label">
          <div class="tech-layer__label-icon">🔀</div>
          <div class="tech-layer__label-text">网关层</div>
          <div class="tech-layer__label-sub">Gateway</div>
        </div>
        <div class="tech-layer__content">
          <div class="tech-node tech-node--indigo"><div class="tech-node__dot"></div>Nginx · 反向代理</div>
          <div class="tech-node tech-node--indigo"><div class="tech-node__dot"></div>API Gateway · 路由分发</div>
          <div class="tech-node tech-node--indigo"><div class="tech-node__dot"></div>SSL 终止 / 负载均衡</div>
          <div class="tech-node tech-node--indigo"><div class="tech-node__dot"></div>Rate Limiting · 限流</div>
        </div>
      </div>

      <div class="tech-flow">
        <div class="tech-flow__line">
          <div class="tech-flow__arrow">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94A3B8" stroke-width="2"><path d="M12 5v14M19 12l-7 7-7-7"/></svg>
            RESTful API
          </div>
          <div class="tech-flow__arrow">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94A3B8" stroke-width="2"><path d="M12 5v14M19 12l-7 7-7-7"/></svg>
            JWT Auth
          </div>
        </div>
      </div>

      <!-- Layer 3: Business Service -->
      <div class="tech-layer">
        <div class="tech-layer__label">
          <div class="tech-layer__label-icon">⚙️</div>
          <div class="tech-layer__label-text">业务服务层</div>
          <div class="tech-layer__label-sub">Services</div>
        </div>
        <div class="tech-layer__content">
          <div class="tech-node tech-node--blue"><div class="tech-node__dot"></div>账户服务 · Account</div>
          <div class="tech-node tech-node--cyan"><div class="tech-node__dot"></div>资金服务 · Payment</div>
          <div class="tech-node tech-node--violet"><div class="tech-node__dot"></div>用户服务 · User</div>
          <div class="tech-node tech-node--amber"><div class="tech-node__dot"></div>权限服务 · RBAC</div>
          <div class="tech-node tech-node--emerald"><div class="tech-node__dot"></div>消息服务 · Notification</div>
          <div class="tech-node tech-node--rose"><div class="tech-node__dot"></div>数据服务 · Analytics</div>
          <div class="tech-node tech-node--slate"><div class="tech-node__dot"></div>Java / Spring Boot</div>
          <div class="tech-node tech-node--slate"><div class="tech-node__dot"></div>MyBatis Plus</div>
        </div>
      </div>

      <div class="tech-flow">
        <div class="tech-flow__line">
          <div class="tech-flow__arrow">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94A3B8" stroke-width="2"><path d="M12 5v14M19 12l-7 7-7-7"/></svg>
            TCP / ORM
          </div>
          <div class="tech-flow__arrow">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94A3B8" stroke-width="2"><path d="M12 5v14M19 12l-7 7-7-7"/></svg>
            Cache
          </div>
        </div>
      </div>

      <!-- Layer 4: Data -->
      <div class="tech-layer">
        <div class="tech-layer__label">
          <div class="tech-layer__label-icon">🗄️</div>
          <div class="tech-layer__label-text">数据层</div>
          <div class="tech-layer__label-sub">Data</div>
        </div>
        <div class="tech-layer__content">
          <div class="tech-node tech-node--cyan"><div class="tech-node__dot"></div>MySQL · 主从</div>
          <div class="tech-node tech-node--rose"><div class="tech-node__dot"></div>Redis · 缓存/会话</div>
          <div class="tech-node tech-node--amber"><div class="tech-node__dot"></div>OSS · 文件存储</div>
          <div class="tech-node tech-node--emerald"><div class="tech-node__dot"></div>Elasticsearch · 日志</div>
        </div>
      </div>

      <div class="tech-flow">
        <div class="tech-flow__line">
          <div class="tech-flow__arrow">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94A3B8" stroke-width="2"><path d="M12 5v14M19 12l-7 7-7-7"/></svg>
            HTTPS / OAuth2
          </div>
        </div>
      </div>

      <!-- Layer 5: External Integration -->
      <div class="tech-layer">
        <div class="tech-layer__label">
          <div class="tech-layer__label-icon">🔗</div>
          <div class="tech-layer__label-text">外部集成</div>
          <div class="tech-layer__label-sub">Integration</div>
        </div>
        <div class="tech-layer__content">
          <div class="tech-node tech-node--blue"><div class="tech-node__dot"></div>Google Ads API</div>
          <div class="tech-node tech-node--indigo"><div class="tech-node__dot"></div>Facebook Marketing API</div>
          <div class="tech-node tech-node--rose"><div class="tech-node__dot"></div>TikTok Ads API</div>
          <div class="tech-node tech-node--cyan"><div class="tech-node__dot"></div>Bing Ads API</div>
          <div class="tech-node tech-node--slate"><div class="tech-node__dot"></div>Twitter / Taboola / Outbrain</div>
          <div class="tech-node tech-node--emerald"><div class="tech-node__dot"></div>SMTP · 邮件服务</div>
          <div class="tech-node tech-node--amber"><div class="tech-node__dot"></div>SMS · 短信网关</div>
        </div>
      </div>

      <div class="tech-flow">
        <div class="tech-flow__line">
          <div class="tech-flow__arrow">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94A3B8" stroke-width="2"><path d="M12 5v14M19 12l-7 7-7-7"/></svg>
            CI/CD
          </div>
        </div>
      </div>

      <!-- Layer 6: Infrastructure -->
      <div class="tech-layer">
        <div class="tech-layer__label">
          <div class="tech-layer__label-icon">☁️</div>
          <div class="tech-layer__label-text">基础设施</div>
          <div class="tech-layer__label-sub">Infrastructure</div>
        </div>
        <div class="tech-layer__content">
          <div class="tech-node tech-node--indigo"><div class="tech-node__dot"></div>Docker · 容器化</div>
          <div class="tech-node tech-node--indigo"><div class="tech-node__dot"></div>Kubernetes · 编排调度</div>
          <div class="tech-node tech-node--emerald"><div class="tech-node__dot"></div>GitLab CI · 持续集成</div>
          <div class="tech-node tech-node--amber"><div class="tech-node__dot"></div>Prometheus + Grafana · 监控</div>
          <div class="tech-node tech-node--rose"><div class="tech-node__dot"></div>ELK · 日志采集</div>
          <div class="tech-node tech-node--slate"><div class="tech-node__dot"></div>阿里云 · 云基础设施</div>
        </div>
      </div>
    </div>

    <div class="arch-legend">
      <div class="arch-legend__item"><div class="arch-legend__icon" style="background:#2563EB;"></div>前端 / 客户端</div>
      <div class="arch-legend__item"><div class="arch-legend__icon" style="background:#6366F1;"></div>网关 / 基础设施</div>
      <div class="arch-legend__item"><div class="arch-legend__icon" style="background:#8B5CF6;"></div>业务服务</div>
      <div class="arch-legend__item"><div class="arch-legend__icon" style="background:#06B6D4;"></div>数据 / 资金</div>
      <div class="arch-legend__item"><div class="arch-legend__icon" style="background:#F59E0B;"></div>权限 / 监控</div>
      <div class="arch-legend__item"><div class="arch-legend__icon" style="background:#10B981;"></div>消息 / 集成</div>
      <div class="arch-legend__item"><div class="arch-legend__icon" style="background:#F43F5E;"></div>分析 / 日志</div>
    </div>
  </div>

  <div class="s-divider"></div>

  <!-- ======================== UI SHOWCASE ======================== -->
  <div class="section">
    <div class="sec-label">
      <div class="sec-label__dot" style="background:#06B6D4;"></div>
      <span class="sec-label__cn">界面展示</span>
      <span class="sec-label__sep">/</span>
      <span class="sec-label__en">UI Showcase</span>
    </div>
    <div class="ui-grid">
      <!-- Client: Login -->
      <div class="ui-card">
        <div class="ui-card__mockup">
          <div class="browser-chrome">
            <div class="browser-chrome__dots">
              <div class="browser-chrome__dot red"></div>
              <div class="browser-chrome__dot yellow"></div>
              <div class="browser-chrome__dot green"></div>
            </div>
            <div class="browser-chrome__url"></div>
          </div>
          <img class="ui-card__img" alt="客户端登录页" :src="getImage('login-form.png')" @error="onImageError" />
        </div>
        <div class="ui-card__info">
          <div class="ui-card__title">客户端 — 登录页</div>
          <div class="ui-card__desc">支持邮箱+密码与邮箱验证码两种登录方式，集成服务协议与隐私政策确认</div>
          <span class="ui-card__tag client">Client</span>
        </div>
      </div>

      <!-- Client: Workspace -->
      <div class="ui-card">
        <div class="ui-card__mockup">
          <div class="browser-chrome">
            <div class="browser-chrome__dots">
              <div class="browser-chrome__dot red"></div>
              <div class="browser-chrome__dot yellow"></div>
              <div class="browser-chrome__dot green"></div>
            </div>
            <div class="browser-chrome__url"></div>
          </div>
          <img class="ui-card__img" alt="客户端工作台" :src="getImage('client-dashboard.png')" @error="onImageError" />
        </div>
        <div class="ui-card__info">
          <div class="ui-card__title">客户端 — 工作台</div>
          <div class="ui-card__desc">一站式数据看板，账户概览、资产概览、充值任务与广告数据一目了然</div>
          <span class="ui-card__tag client">Client</span>
        </div>
      </div>

      <!-- Client: Account Opening -->
      <div class="ui-card">
        <div class="ui-card__mockup">
          <div class="browser-chrome">
            <div class="browser-chrome__dots">
              <div class="browser-chrome__dot red"></div>
              <div class="browser-chrome__dot yellow"></div>
              <div class="browser-chrome__dot green"></div>
            </div>
            <div class="browser-chrome__url"></div>
          </div>
          <img class="ui-card__img" alt="客户端开户申请" :src="getImage('account-opening.png')" @error="onImageError" />
        </div>
        <div class="ui-card__info">
          <div class="ui-card__title">客户端 — 开户申请</div>
          <div class="ui-card__desc">展示14种广告媒体列表，支持快速发起开户申请与开户记录查看</div>
          <span class="ui-card__tag client">Client</span>
        </div>
      </div>

      <!-- Client: Account List -->
      <div class="ui-card">
        <div class="ui-card__mockup">
          <div class="browser-chrome">
            <div class="browser-chrome__dots">
              <div class="browser-chrome__dot red"></div>
              <div class="browser-chrome__dot yellow"></div>
              <div class="browser-chrome__dot green"></div>
            </div>
            <div class="browser-chrome__url"></div>
          </div>
          <img class="ui-card__img" alt="客户端账户列表" :src="getImage('account-list.png')" @error="onImageError" />
        </div>
        <div class="ui-card__info">
          <div class="ui-card__title">客户端 — 账户列表</div>
          <div class="ui-card__desc">多Tab切换媒体类型，支持批量充值/清零/绑定/解绑等操作</div>
          <span class="ui-card__tag client">Client</span>
        </div>
      </div>

      <!-- Client: Wallet Recharge -->
      <div class="ui-card">
        <div class="ui-card__mockup">
          <div class="browser-chrome">
            <div class="browser-chrome__dots">
              <div class="browser-chrome__dot red"></div>
              <div class="browser-chrome__dot yellow"></div>
              <div class="browser-chrome__dot green"></div>
            </div>
            <div class="browser-chrome__url"></div>
          </div>
          <img class="ui-card__img" alt="客户端钱包充值" :src="getImage('wallet-recharge.png')" @error="onImageError" />
        </div>
        <div class="ui-card__info">
          <div class="ui-card__title">客户端 — 钱包充值</div>
          <div class="ui-card__desc">自助充值流程，钱包余额管理与充值记录查看</div>
          <span class="ui-card__tag client">Client</span>
        </div>
      </div>

      <!-- Client: Account Operations -->
      <div class="ui-card">
        <div class="ui-card__mockup">
          <div class="browser-chrome">
            <div class="browser-chrome__dots">
              <div class="browser-chrome__dot red"></div>
              <div class="browser-chrome__dot yellow"></div>
              <div class="browser-chrome__dot green"></div>
            </div>
            <div class="browser-chrome__url"></div>
          </div>
          <img class="ui-card__img" alt="客户端账户操作" :src="getImage('account-operations.png')" @error="onImageError" />
        </div>
        <div class="ui-card__info">
          <div class="ui-card__title">客户端 — 账户操作</div>
          <div class="ui-card__desc">账户详情页，支持充值、清零、绑定、解绑等精细化管理操作</div>
          <span class="ui-card__tag client">Client</span>
        </div>
      </div>

      <!-- Admin: Workspace -->
      <div class="ui-card">
        <div class="ui-card__mockup">
          <div class="browser-chrome">
            <div class="browser-chrome__dots">
              <div class="browser-chrome__dot red"></div>
              <div class="browser-chrome__dot yellow"></div>
              <div class="browser-chrome__dot green"></div>
            </div>
            <div class="browser-chrome__url"></div>
          </div>
          <img class="ui-card__img" alt="管理端工作台" :src="getImage('admin-dashboard.png')" @error="onImageError" />
        </div>
        <div class="ui-card__info">
          <div class="ui-card__title">管理端 — 工作台</div>
          <div class="ui-card__desc">全局数据看板，待处理任务汇总，客户与媒体充值排行榜</div>
          <span class="ui-card__tag admin">Admin</span>
        </div>
      </div>

      <!-- Admin: Client Detail -->
      <div class="ui-card">
        <div class="ui-card__mockup">
          <div class="browser-chrome">
            <div class="browser-chrome__dots">
              <div class="browser-chrome__dot red"></div>
              <div class="browser-chrome__dot yellow"></div>
              <div class="browser-chrome__dot green"></div>
            </div>
            <div class="browser-chrome__url"></div>
          </div>
          <img class="ui-card__img" alt="管理端客户详情" :src="getImage('admin-customer-detail.png')" @error="onImageError" />
        </div>
        <div class="ui-card__info">
          <div class="ui-card__title">管理端 — 客户详情</div>
          <div class="ui-card__desc">客户全貌：基本信息、垫资额度、费项配置、账户分配</div>
          <span class="ui-card__tag admin">Admin</span>
        </div>
      </div>

      <!-- Admin: Agent Stats -->
      <div class="ui-card">
        <div class="ui-card__mockup">
          <div class="browser-chrome">
            <div class="browser-chrome__dots">
              <div class="browser-chrome__dot red"></div>
              <div class="browser-chrome__dot yellow"></div>
              <div class="browser-chrome__dot green"></div>
            </div>
            <div class="browser-chrome__url"></div>
          </div>
          <img class="ui-card__img" alt="管理端代理统计" :src="getImage('admin-agent-stats.png')" @error="onImageError" />
        </div>
        <div class="ui-card__info">
          <div class="ui-card__title">管理端 — 代理统计</div>
          <div class="ui-card__desc">代理商业绩数据统计与分析，多维度数据展示</div>
          <span class="ui-card__tag admin">Admin</span>
        </div>
      </div>

      <!-- Admin: Performance -->
      <div class="ui-card">
        <div class="ui-card__mockup">
          <div class="browser-chrome">
            <div class="browser-chrome__dots">
              <div class="browser-chrome__dot red"></div>
              <div class="browser-chrome__dot yellow"></div>
              <div class="browser-chrome__dot green"></div>
            </div>
            <div class="browser-chrome__url"></div>
          </div>
          <img class="ui-card__img" alt="管理端业绩统计" :src="getImage('admin-performance-stats.png')" @error="onImageError" />
        </div>
        <div class="ui-card__info">
          <div class="ui-card__title">管理端 — 业绩统计</div>
          <div class="ui-card__desc">多维度业绩数据统计报表，支持时间筛选与数据导出</div>
          <span class="ui-card__tag admin">Admin</span>
        </div>
      </div>

      <!-- Admin: Message Notification -->
      <div class="ui-card">
        <div class="ui-card__mockup">
          <div class="browser-chrome">
            <div class="browser-chrome__dots">
              <div class="browser-chrome__dot red"></div>
              <div class="browser-chrome__dot yellow"></div>
              <div class="browser-chrome__dot green"></div>
            </div>
            <div class="browser-chrome__url"></div>
          </div>
          <img class="ui-card__img" alt="管理端消息通知" :src="getImage('admin-notifications.png')" @error="onImageError" />
        </div>
        <div class="ui-card__info">
          <div class="ui-card__title">管理端 — 消息通知</div>
          <div class="ui-card__desc">定向消息推送管理，支持选择客户群体与消息内容配置</div>
          <span class="ui-card__tag admin">Admin</span>
        </div>
      </div>

      <!-- Admin: Wallet Flow -->
      <div class="ui-card">
        <div class="ui-card__mockup">
          <div class="browser-chrome">
            <div class="browser-chrome__dots">
              <div class="browser-chrome__dot red"></div>
              <div class="browser-chrome__dot yellow"></div>
              <div class="browser-chrome__dot green"></div>
            </div>
            <div class="browser-chrome__url"></div>
          </div>
          <img class="ui-card__img" alt="管理端钱包流水" :src="getImage('admin-wallet-ledger.png')" @error="onImageError" />
        </div>
        <div class="ui-card__info">
          <div class="ui-card__title">管理端 — 钱包流水</div>
          <div class="ui-card__desc">全量资金流水记录，支持筛选查询与数据审计</div>
          <span class="ui-card__tag admin">Admin</span>
        </div>
      </div>
    </div>
  </div>

  <div class="s-divider"></div>

  <!-- ======================== FEATURE DETAILS ======================== -->
  <div class="section">
    <div class="sec-label">
      <div class="sec-label__dot" style="background:#8B5CF6;"></div>
      <span class="sec-label__cn">核心能力</span>
      <span class="sec-label__sep">/</span>
      <span class="sec-label__en">Core Capabilities</span>
    </div>
    <div class="feature-list">
      <div class="feature-item">
        <div class="feature-item__icon" style="background:rgba(37,99,235,0.1);">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2563EB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
        </div>
        <div class="feature-item__content">
          <div class="feature-item__title">全媒体开户自动化</div>
          <div class="feature-item__desc">
            覆盖 Google、Facebook、TikTok、Bing、Twitter、Taboola、Outbrain、Yandex、Snapchat、Kwai 等 14 种主流广告媒体。每种媒体根据其平台特性定制独立的申请表单（MCC授权/邮箱授权/BM ID/粉丝页等），通过标准化的审核流程实现高效开户。
          </div>
          <div class="feature-item__tags">
            <span class="feature-item__tag">Google</span>
            <span class="feature-item__tag">Facebook</span>
            <span class="feature-item__tag">TikTok</span>
            <span class="feature-item__tag">Bing</span>
            <span class="feature-item__tag">Twitter</span>
            <span class="feature-item__tag">+9种媒体</span>
          </div>
        </div>
      </div>

      <div class="feature-item">
        <div class="feature-item__icon" style="background:rgba(99,102,241,0.1);">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#6366F1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/></svg>
        </div>
        <div class="feature-item__content">
          <div class="feature-item__title">全链路资金管理</div>
          <div class="feature-item__desc">
            从钱包充值到广告账户到账的完整资金链路。支持钱包余额管理、广告账户充值/清零、资金流水记录等多维度资金操作。管理端可实时监控钱包流水与资金安全，支持充值对账与报表导出。
          </div>
          <div class="feature-item__tags">
            <span class="feature-item__tag">钱包充值</span>
            <span class="feature-item__tag">账户充值</span>
            <span class="feature-item__tag">账户清零</span>
            <span class="feature-item__tag">资金流水</span>
          </div>
        </div>
      </div>

      <div class="feature-item">
        <div class="feature-item__icon" style="background:rgba(139,92,246,0.1);">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#8B5CF6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/><polyline points="7.5 4.21 12 6.81 16.5 4.21"/><polyline points="7.5 19.79 7.5 14.6 3 12"/><polyline points="21 12 16.5 14.6 16.5 19.79"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>
        </div>
        <div class="feature-item__content">
          <div class="feature-item__title">精细化权限体系</div>
          <div class="feature-item__desc">
            管理端角色权限精确至页面级控制，支持后台用户管理、客户分层（代理/直客）、垫资额度配置与费项管理。多角色协同，确保资金操作安全可控。
          </div>
          <div class="feature-item__tags">
            <span class="feature-item__tag">角色权限</span>
            <span class="feature-item__tag">客户分层</span>
            <span class="feature-item__tag">垫资额度</span>
            <span class="feature-item__tag">费项配置</span>
          </div>
        </div>
      </div>

      <div class="feature-item">
        <div class="feature-item__icon" style="background:rgba(6,182,212,0.1);">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#06B6D4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 20V10"/><path d="M12 20V4"/><path d="M6 20v-6"/></svg>
        </div>
        <div class="feature-item__content">
          <div class="feature-item__title">数据看板与统计</div>
          <div class="feature-item__desc">
            双端工作台实时数据看板：账户空户率、封户数、充值金额、媒体排行榜等。管理端额外支持业绩统计、代理统计等多维分析报表，数据驱动运营决策。
          </div>
          <div class="feature-item__tags">
            <span class="feature-item__tag">实时看板</span>
            <span class="feature-item__tag">业绩统计</span>
            <span class="feature-item__tag">排行榜</span>
            <span class="feature-item__tag">数据导出</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="s-divider"></div>

  <!-- ======================== MEDIA SUPPORT ======================== -->
  <div class="section">
    <div class="sec-label">
      <div class="sec-label__dot" style="background:#F59E0B;"></div>
      <span class="sec-label__cn">支持媒体</span>
      <span class="sec-label__sep">/</span>
      <span class="sec-label__en">Supported Media</span>
    </div>
    <div class="media-grid">
      <div class="media-chip"><div class="media-chip__dot" style="background:#4285F4;"></div>Google</div>
      <div class="media-chip"><div class="media-chip__dot" style="background:#34A853;"></div>Google海外</div>
      <div class="media-chip"><div class="media-chip__dot" style="background:#EA4335;"></div>Google老户</div>
      <div class="media-chip"><div class="media-chip__dot" style="background:#1877F2;"></div>Facebook</div>
      <div class="media-chip"><div class="media-chip__dot" style="background:#1877F2;"></div>FB两不限</div>
      <div class="media-chip"><div class="media-chip__dot" style="background:#1877F2;"></div>FB三不限</div>
      <div class="media-chip"><div class="media-chip__dot" style="background:#008373;"></div>Bing</div>
      <div class="media-chip"><div class="media-chip__dot" style="background:#000000;"></div>TikTok</div>
      <div class="media-chip"><div class="media-chip__dot" style="background:#1DA1F2;"></div>Twitter</div>
      <div class="media-chip"><div class="media-chip__dot" style="background:#0052CC;"></div>Taboola</div>
      <div class="media-chip"><div class="media-chip__dot" style="background:#F76B1C;"></div>Outbrain</div>
      <div class="media-chip"><div class="media-chip__dot" style="background:#FF0000;"></div>Yandex</div>
      <div class="media-chip"><div class="media-chip__dot" style="background:#FFFC00;"></div>Snapchat</div>
      <div class="media-chip"><div class="media-chip__dot" style="background:#FF4500;"></div>Kwai</div>
    </div>
  </div>

  <div class="s-divider"></div>

  <!-- ======================== DESIGN SYSTEM ======================== -->
  <div class="section">
    <div class="sec-label">
      <div class="sec-label__dot" style="background:#10B981;"></div>
      <span class="sec-label__cn">设计规范</span>
      <span class="sec-label__sep">/</span>
      <span class="sec-label__en">Design System</span>
    </div>
    <div class="design-grid">
      <div class="design-panel">
        <div class="design-panel__title">色彩系统</div>
        <div class="color-swatches">
          <div class="color-swatch">
            <div class="color-swatch__circle" style="background:#2563EB;"></div>
            <span class="color-swatch__label">Primary</span>
          </div>
          <div class="color-swatch">
            <div class="color-swatch__circle" style="background:#1D4ED8;"></div>
            <span class="color-swatch__label">Dark</span>
          </div>
          <div class="color-swatch">
            <div class="color-swatch__circle" style="background:#3B82F6;"></div>
            <span class="color-swatch__label">Accent</span>
          </div>
          <div class="color-swatch">
            <div class="color-swatch__circle" style="background:#DBEAFE;"></div>
            <span class="color-swatch__label">Light</span>
          </div>
          <div class="color-swatch">
            <div class="color-swatch__circle" style="background:#0F172A;"></div>
            <span class="color-swatch__label">Text</span>
          </div>
          <div class="color-swatch">
            <div class="color-swatch__circle" style="background:#64748B;"></div>
            <span class="color-swatch__label">Muted</span>
          </div>
          <div class="color-swatch">
            <div class="color-swatch__circle" style="background:#E2E8F0;"></div>
            <span class="color-swatch__label">Border</span>
          </div>
          <div class="color-swatch">
            <div class="color-swatch__circle" style="background:#7C3AED;"></div>
            <span class="color-swatch__label">Admin</span>
          </div>
        </div>
      </div>
      <div class="design-panel">
        <div class="design-panel__title">字体排版</div>
        <div class="typo-list">
          <div class="typo-item">
            <span class="typo-item__sample">渠道广告资金管理台</span>
            <span class="typo-item__meta">Noto Sans SC Bold 36px</span>
          </div>
          <div class="typo-item">
            <span class="typo-item__sample" style="font-size:16px;font-weight:700;">全媒体账户管理</span>
            <span class="typo-item__meta">Noto Sans SC Bold 16px</span>
          </div>
          <div class="typo-item">
            <span class="typo-item__sample" style="font-size:14px;font-weight:400;color:var(--text-secondary);">数据看板实时展示关键业务指标</span>
            <span class="typo-item__meta">Noto Sans SC Regular 14px</span>
          </div>
          <div class="typo-item">
            <span class="typo-item__sample" style="font-size:12px;font-weight:500;color:var(--text-muted);font-family:'Inter',sans-serif;">Label / Tag / Caption</span>
            <span class="typo-item__meta">Inter Medium 12px</span>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>

<!-- Page Summary -->
<section class="page-summary">
  <div class="page-summary__inner">
    <p class="page-summary__text fontRegular">{{ detailIntroduction }}</p>
    <div class="page-summary__preview">
      <img
        v-for="(img, index) in previewImages"
        :key="'preview-' + index"
        :src="img"
        alt=""
      />
    </div>
    <div class="page-summary__back fontRegular" @click="goBack">返回</div>
  </div>
</section>

<!-- Related Cases -->
<section class="related-cases">
  <div class="related-cases__inner">
    <div class="related-cases__title">
      <img :src="caseListText" alt="相关案例" />
    </div>
    <div class="related-cases__grid">
      <list-card
        v-for="(item, index) in relatedCaseList"
        :key="'related-case-' + index"
        class="noPadding"
        :src="item.image"
        :routeQuery="item.routeQuery"
        :keyIndex="index"
        :showDownName="false"
        :isRichHtml="true"
        :showFreeTrialTag="item.showFreeTrialTag"
        :backgroundColor="item.backgroundColor"
      />
    </div>
  </div>
</section>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import ListCard from "@/components/list-card/index.vue";
import { initRichHtmlReveal } from "../utils/useRichHtmlReveal";
import imageMap from "./images";

const getImage = (name) => imageMap[name] || "";

const bannerDashboardImage = getImage("client-dashboard.png");

const onImageError = (event) => {
  const target = event.target;
  if (target) {
    target.style.display = "none";
  }
};

const introduceText = require("@/assets/images/introduce-text.png");
const caseListText = require("@/assets/images/case-list-text.png");

const projectIntroduction =
  "面向跨境广告渠道商的全媒体广告账户与资金一站式管理平台。涵盖 Google、Facebook、TikTok 等 14 种主流广告媒体的账户开户、资金充值、账户管理与数据看板，实现客户端自助操作与管理端精细化运营的双端协同。";

const detailIntroduction =
  "云效科技崇尚创新，专注研发，拥有一支国内领先的技术团队，并凭借专业知识强、业务技术精、服务质量高、精神面貌佳等特点得到用户的一致赞誉。在软件开发的专业领域，云效科技与行业内诸多知名企业保持有长期稳定的合作关系。";

const previewImages = [
  require("@/assets/images/list-case/attract-investment/image-1.png"),
];

const relatedCaseList = [
  {
    image: require("@/assets/images/project-list-card/project-36.png"),
    backgroundColor: "#0FBFAE",
    routeQuery: { name: "intelligentElectricAdjustmentSystem", isRichHtml: true },
  },
  {
    image: require("@/assets/images/project-list-card/project-39.png"),
    backgroundColor: "#1C69C7",
    routeQuery: { name: "intelligentPetFeeder", isRichHtml: true },
  },
  {
    image: require("@/assets/images/project-list-card/project-37.png"),
    backgroundColor: "#09C9B0",
    routeQuery: { name: "lovableHome", isRichHtml: true },
  },
];

const router = useRouter();
const rootRef = ref(null);

const goBack = () => {
  router.go(-1);
};

onMounted(() => {
  initRichHtmlReveal(rootRef.value);
});
</script>

<style lang="scss" src="./case.scss"></style>
<style lang="scss" src="./banner.scss"></style>
<style lang="scss" src="./layout.scss"></style>
